import * as yup from "yup";

declare module "yup" {
  interface StringSchema {
    time(): this;
  }
}

yup.addMethod(yup.StringSchema, "time", function () {
  return this.test({
    name: "time",
    message: "text must be in format 'H:mm'",
    test: (value) => /^(\d|1\d|2[0-3]):[0-5]\d$/.test(value),
  });
});
